import { UserData } from "../context/user-data-context";
import { IDelayQuestions } from "../types/questions";
import { User } from "../types/user";

export const createObjectQuestions = (
    userData: UserData, 
    choices: any, 
    ed50Value: any, 
    kValue: any,
    startedAt: string,
    completedAt: string,
    companyId: string, 
    me: User | null
): IDelayQuestions => {
    const totalTimeSeconds = Math.floor(
        (new Date(completedAt).getTime() - new Date(startedAt).getTime()) / 1000
    );

    return {
        record_id: userData.record_id || '',
        nome: userData.nome || '',
        dtnasc: userData.dtnasc || '',
        valor_imediato: '500',
        valor_atrasado: '1000',
        r1_indice: '16',
        r1_tempo: choices[0].elapsedTime.toString(),
        r1_escolha: choices[0].choice,
        r2_indice: choices[1].currentIndex.toString(),
        r2_tempo: choices[1].elapsedTime.toString(),
        r2_escolha: choices[1].choice,
        r3_indice: choices[2].currentIndex.toString(),
        r3_tempo: choices[2].elapsedTime.toString(),
        r3_escolha: choices[2].choice,
        r4_indice: choices[3].currentIndex.toString(),
        r4_tempo: choices[3].elapsedTime.toString(),
        r4_escolha: choices[3].choice,
        r5_indice: choices[4].currentIndex.toString(),
        r5_tempo: choices[4].elapsedTime.toString(),
        r5_escolha: choices[4].choice,
        ed50: ed50Value?.toString() || '0',
        k: kValue?.toString() || '0',
        companyId: companyId,
        typeQuestionId: '3',
        startedAt: startedAt,
        completedAt: completedAt,
        totalTimeSeconds: totalTimeSeconds,
        applicatorId: me?.id || ''
    };    
};